"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.domainFiltersStyles = void 0;
var _core = require("@linaria/core");
var _intents = _interopRequireDefault(require("@ux/intents"));
const intents = new _intents.default();

// Global CSS imports
"d19aojrb";
const domainFiltersStyles = exports.domainFiltersStyles = {
  container: "c130k29",
  mobileHeader: "mhf4tkh",
  mobileTitle: "ml00ph",
  filterIconWrapper: "f1gqgh7n",
  titleText: "t9vypjq",
  closeButton: "c133lx6b",
  section: "s9qsa2v",
  sectionContent: "str941t",
  sectionTitle: "s1nxonml",
  sortOptions: "sz57x2p",
  sortOption: "sh09dyn",
  sortOptionSelected: "s14izmnt",
  sortOptionText: "sizpe7y",
  sortOptionSubtitle: "s19nld42",
  radioIndicator: "r1ecaxe",
  radioIndicatorSelected: "rhi56y9",
  clearIconWrapper: "c1xr73a0",
  tldContainer: "t1e0fflm",
  tldGrid: "t131aof7",
  tldButton: "t5a73o7",
  tldButtonSelected: "t1tedmi0",
  clearAllButton: "c12hk5kh"
};